import type { ReminderConfiguration } from '@/schema'

export function getThresholdDescription(
  reminder: ReminderConfiguration,
  t: (key: string, options?: Record<string, unknown>) => string
): string {
  const { value, unit } = reminder

  // Handle negative values (overdue reminders)
  if (value < 0) {
    return t('workflowConfig.reminderDescription.overdue')
  }

  switch (unit) {
    case 'days':
      if (value === 0) return t('workflowConfig.reminderDescription.onDueDate')
      return t('workflowConfig.reminderDescription.daysBefore', {
        count: value,
      })
    case 'hours':
      return t('workflowConfig.reminderDescription.hoursBefore', {
        count: value,
      })
    case 'weeks':
      return t('workflowConfig.reminderDescription.weeksBefore', {
        count: value,
      })
    default:
      return `${value} ${unit}`
  }
}
